const PREFIX = "Metadata";
export const SET_SELECTED_SECTION = `${PREFIX}_SET_SELECTED_SECTION`;
export const SET_SHOW_MISLABEL_RANGE = `${PREFIX}_SET_SHOW_MISLABEL_RANGE`;
export const SET_SHOW_DUPLICATE_RANGE = `${PREFIX}_SET_SHOW_DUPLICATE_RANGE`;
